export const ShipperMarket = {
  Contracted: 'contracted',
  Spot: 'spot',
}

export const LoadFeatures = {
  FastFacility: 'fast_facility',
  TopRatedFacility: 'top_rated_facility',
  EarlyAppointment: 'early_appointment',
  Palletized: 'palletized',
}

export const LoadModes = {
  FTL: 'FTL',
  PTL: 'PTL',
}
